import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from "rxjs";;
import { ApplicationSectionBaseComponent } from "../../../application-section-base/application-section-base.component";
import { ApplicationSteps } from "../../../../models/applications.models";
import { AuthService } from "../../../../../services/auth.service";
import { DomainDefinitionService } from "../../../../../builder/services/domain-definition.service";
import { IUploadFile } from '../../../../../common/services/document-management.service';
import { OnBaseDocumentTypeProcessReference, OnBaseSubProcessName } from '../../../../../common/models/onBaseIntegrationAndMapping.model';

@Component({
    selector: 'app-stratigraphic-review',
    templateUrl: './stratigraphic-review.component.html',
    styleUrls: ['./stratigraphic-review.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss', '../../../application-section-base/application-section-base.component.scss'],
    standalone: false
})
export class StratigraphicReviewComponent extends ApplicationSectionBaseComponent implements OnInit, OnDestroy {

    @Input() onBaseDocumentTypes: OnBaseDocumentTypeProcessReference[] = [];

    readonly step: ApplicationSteps = ApplicationSteps.Review;

    get applicationCompleteDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('completeDate');
        if (ctrl == null) return null;
        return ctrl.value != null ? new Date(ctrl.value) : null;
    }

    set applicationCompleteDate(value: Date) {
        if (this.form == null) return;
        let ctrl = this.form.get('completeDate');
        if (ctrl == null) return;
        ctrl.setValue(value);
    }

    private _isDrill: boolean = true;

    get isDrill(): boolean {
        return this._isDrill;
    }

    @Input() set isDrill(value: boolean) {
        this._isDrill = value;
    }

    subscription: Subscription = new Subscription();

    updatedAPIHelpText: string = "e.g., if the Side Track or Completion numbers need to be updated. <br />API #'s must be provided as 14-digit numbers.";


    constructor(_auth: AuthService, private domainService: DomainDefinitionService) { super(_auth); }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    completeDateChanged(model: Date): void {
        this.applicationCompleteDate = model;
    }

    documentTypeLookup(fieldName: string): string {
        let docType: string = "";
        switch (fieldName) {
            case "twentyFortyAcre": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialCondition2040Acre)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "annualDisposal": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionAnnualDisposal)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "annularDisposal": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionAnnularDisposal)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "ashtabulaDevonianFluidRotary": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionAshtabulaDevonianFluidRotary)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "ashtabulaDevonianOriskany": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionAshtabulaDevonianOriskany)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "enhancedRecovery": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionEnhancedRecovery)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "conductorMineStringComboBasket": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionConductorMineStringComboBasket)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "directionalDrilling": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionDirectionalDrilling)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "failureToMaintainInsurance": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionFailureToMaintainInsuranceCoverage)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "fluidRotaryLakePlainOriskany": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionFluidRotaryLakePlainOriskany)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "horizontalDrilling": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionHorizontalDrilling)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "hydrogenSulfide": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionHydrogenSulfide)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "ielSuperfund": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionIelSuperfund)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "knoxUnconformity": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionKnoxUnconformity)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "lakePlainRegionOriskany": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionLakePlainsOriskany)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "lakePlainRegionUtica": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionLakePlainsUtica)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "mineStringBasketVoid": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionsMineStringBasketVoid450)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "mineStringBasketGreaterThreeHundred": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionsMineStringBasketVoidGreater300)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "mineStringBasketLessThanThreeHundred": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionMineStringBasketVoidLess300)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "municipalWellheadProtection": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionMunicipalWellheadProtectionClinton)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "municipalWellheadProtectionQueenston": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionMunicipalWellheadProtectionQueenston)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "noPerforationZone": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionNoPerforationZone)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "noiseMitigation": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionNoiseMitigation)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "oldWellUnknownStatus": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionOldWellUnknownStatus)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "otherConditions": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionOther)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "prePermittingShaleSite": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionPrepermittingShale)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "prePermittingUrbanSite": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionPrepermittingUrban)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "removalOfFluidHorizontalShale": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionRemovalOfFluid)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "seismicActivity": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionSeismicActivity)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "shallowGas": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionShallowGas)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "ssm1": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionSsm1)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "ssm4": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionSsm4)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "swiw": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionSwiw)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "surfaceCasingMineStringCombo": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionSurfaceCasingMineStringCombo)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "surfaceCasingMineStringComboBasket": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionSurfaceCasingMineStringComboBasket)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "thinGlacialTillQueenston": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionThinGlacialTillQueenston)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "thinGlacialTillClinton": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionThinGlacialTillClinton)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "trempealeau": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionTrempealeau)?.onBaseDocumentTypeName ?? "";
                break;
            }
            case "wellInAOR": {
                docType = this.onBaseDocumentTypes.find(d => d.subProcessName == OnBaseSubProcessName.SpecialConditionWellInAor)?.onBaseDocumentTypeName ?? "";
                break;
            }
        }
        return docType;
    }

    fileAdded(evt: IUploadFile, field: string): void {
        let ctrl = this.findMatchingControl(`specialConditions|${field}`);
        if (ctrl != null) {
            const files: IUploadFile[] = <IUploadFile[]>ctrl.value;
            const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
            if (isNew) {
                evt.documentType = this.documentTypeLookup(field);
                files.push(evt);
                ctrl.setValue(files);
            }
        }
    }

    fileRemoved(evt: IUploadFile, field: string): void {
        let ctrl = this.findMatchingControl(`specialConditions|${field}`);
        if (ctrl != null) {
            const files: IUploadFile[] = <IUploadFile[]>ctrl.value;
            const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
            if (fileIndex !== -1) {
                files.splice(fileIndex, 1);
                ctrl.setValue(files);
            }
        }
    }


    toggleOpen(): void {
        if (this.step == this.activeStep || !this.isOpen) super.toggleOpen();
        this.openChanged.emit(this.step);
    }

}
